module.exports = __webpack_public_path__ + "img/0-26.7bb75f3a.gif";